import createApp from '@shopify/app-bridge';
import { getSessionToken } from '@shopify/app-bridge-utils';

// Returns a promise that resolves to the session token
export async function fetchSessionToken(app) {
  return await getSessionToken(app);
}
